import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-529170ea"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  style: {"min-width":"125px"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Standort:", -1))
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "CEO:", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Phone:", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Standort:", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Add Marker", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headline" }, "Edit Marker", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_error_snackbar = _resolveComponent("error-snackbar")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_l_tile_layer = _resolveComponent("l-tile-layer")!
  const _component_l_popup = _resolveComponent("l-popup")!
  const _component_l_marker = _resolveComponent("l-marker")!
  const _component_l_map = _resolveComponent("l-map")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_error_snackbar, {
      snackbar: _ctx.errorSnackbar,
      "onUpdate:snackbar": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.errorSnackbar) = $event))
    }, null, 8, ["snackbar"]),
    _createVNode(_component_v_container, {
      fluid: "",
      class: "outer-container"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "map-container"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeMapStyle('styleAtlas')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Atlas")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changeMapStyle('styleSatelite')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Satelite")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeMapStyle('styleGrid')))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Grid")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, { style: {"height":"100%"} }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "9" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_l_map, {
                      ref: "map",
                      class: "map-container",
                      zoom: 4,
                      center: _ctx.center,
                      options: _ctx.mapOptions,
                      onDblclick: _ctx.onMapClick
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_l_tile_layer, {
                          url: _ctx.url,
                          attribution: _ctx.attribution
                        }, null, 8, ["url", "attribution"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMarkers, (marker) => {
                          return (_openBlock(), _createBlock(_component_l_marker, {
                            key: marker.id,
                            "lat-lng": [marker.y_coordinate, marker.x_coordinate],
                            icon: _ctx.customIcon(marker.icon)
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_l_popup, { style: {"min-width":"125px"} }, {
                                default: _withCtx(() => [
                                  (marker.category_id == 1)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _createElementVNode("h3", null, _toDisplayString(marker.name), 1),
                                        _createElementVNode("p", null, [
                                          _hoisted_2,
                                          _createTextVNode(" " + _toDisplayString(marker.location), 1)
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                        _createElementVNode("h3", null, _toDisplayString(marker.name), 1),
                                        _createElementVNode("p", null, [
                                          _hoisted_4,
                                          _createTextVNode(" " + _toDisplayString(marker.ceo), 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_5,
                                          _createTextVNode(" " + _toDisplayString(marker.phonenumber), 1)
                                        ]),
                                        _createElementVNode("p", null, [
                                          _hoisted_6,
                                          _createTextVNode(" " + _toDisplayString(marker.location), 1)
                                        ])
                                      ])),
                                  _createVNode(_component_v_row, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_col, { cols: "5" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            text: "true",
                                            size: "small",
                                            color: "warning",
                                            onClick: ($event: any) => (_ctx.editMarker(marker))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Edit")
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024),
                                      _createVNode(_component_v_col, { cols: "7" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_btn, {
                                            text: "true",
                                            size: "small",
                                            color: "warning",
                                            onClick: ($event: any) => (_ctx.deleteMarker(marker))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Delete")
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1032, ["lat-lng", "icon"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["center", "options", "onDblclick"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_container, { fluid: "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_select, {
                          items: _ctx.categories,
                          "item-title": "name",
                          "item-value": "id",
                          label: "Kategorie",
                          modelValue: _ctx.selectedCategories,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selectedCategories) = $event)),
                          multiple: "",
                          chips: "",
                          filter: "",
                          dense: ""
                        }, null, 8, ["items", "modelValue"]),
                        _createVNode(_component_v_text_field, {
                          label: "Search",
                          modelValue: _ctx.search,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event))
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_expansion_panels, null, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category, index) => {
                              return (_openBlock(), _createBlock(_component_v_expansion_panel, {
                                key: index,
                                title: category.name
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel_text, null, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_list, { dense: "" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredMarkersByCategory(category.id), (marker) => {
                                            return (_openBlock(), _createBlock(_component_v_list_item, {
                                              key: marker.id,
                                              onClick: ($event: any) => (_ctx.focusOnMarker(marker))
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_list_item_title, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(marker.name), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createVNode(_component_v_list_item_subtitle, null, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(marker.location), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024)
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"]))
                                          }), 128))
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1032, ["title"]))
                            }), 128))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.showDialog,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.showDialog) = $event)),
              persistent: "",
              "max-width": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Name",
                                      modelValue: _ctx.markerName,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.markerName) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "CEO",
                                      modelValue: _ctx.ceo,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.ceo) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Phonenumber",
                                      modelValue: _ctx.phonenumber,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.phonenumber) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Standort",
                                      modelValue: _ctx.location,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.location) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.categories,
                                      "item-title": "name",
                                      "item-value": "id",
                                      label: "Category",
                                      modelValue: _ctx.selectedCategory,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.selectedCategory) = $event))
                                    }, null, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          text: "true",
                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showDialog = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Close ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          text: "true",
                          onClick: _ctx.addMarker
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Save ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_v_dialog, {
              modelValue: _ctx.editDialog,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.editDialog) = $event)),
              persistent: "",
              "max-width": "600px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_card_title, null, {
                      default: _withCtx(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_text, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_container, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Name",
                                      modelValue: _ctx.markerName,
                                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.markerName) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "CEO",
                                      modelValue: _ctx.ceo,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.ceo) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Phonenumber",
                                      modelValue: _ctx.phonenumber,
                                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.phonenumber) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field, {
                                      label: "Standort",
                                      modelValue: _ctx.location,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.location) = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select, {
                                      items: _ctx.categories,
                                      "item-title": "name",
                                      "item-value": "id",
                                      label: "Category",
                                      modelValue: _ctx.selectedCategory,
                                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.selectedCategory) = $event))
                                    }, null, 8, ["items", "modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_card_actions, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          text: "true",
                          onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.editDialog = false))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Close ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_btn, {
                          color: "blue darken-1",
                          text: "true",
                          onClick: _ctx.updateMarker
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Save ")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}